export enum MonitorTypes {
    custom = 'custom',
    simple = 'simple'
};
